function getSound(name) {
    return `res/sound/${name}.mp3`;
}
export const PathDefine = {
    getSound,
};
//# sourceMappingURL=PathDefine.js.map